import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import UserNav from './UserNav';
import './MobileTranscriptControls.css';

const MobileTranscriptControls = ({
  typingMode,
  onTypingModeToggle,
  clickToDeleteMode,
  onClickToDeleteModeToggle,
  suggestionsMode,
  onSuggestionsModeToggle,
  onHelpToggle,
  showControls = true,
  showClickToDeleteToggle = false
}) => {
  // Add/remove body class for mobile transcript controls
  useEffect(() => {
    if (showControls && window.innerWidth <= 768) {
      document.body.classList.add('mobile-transcript-active');
    } else {
      document.body.classList.remove('mobile-transcript-active');
    }

    return () => {
      document.body.classList.remove('mobile-transcript-active');
    };
  }, [showControls]);

  if (!showControls) {
    return null;
  }

  return (
    <div className="mobile-transcript-controls-editing">
      {onHelpToggle && (
        <button
          className="mobile-control-btn mobile-help-btn-left"
          onClick={onHelpToggle}
          title="Help"
          type="button"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14C9.79 6 8 7.79 8 10h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"/>
          </svg>
        </button>
      )}
      <div className="mobile-edit-spacer"></div>
      <div className="mobile-edit-buttons-wrapper">
      <button
        className={`mobile-control-btn mobile-edit-btn ${typingMode ? 'active' : ''}`}
        onClick={onTypingModeToggle}
        title="Toggle typing mode for editing"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
        </svg>
      </button>

      {showClickToDeleteToggle && (
        <button
          className={`mobile-control-btn mobile-delete-btn ${clickToDeleteMode ? 'active' : ''}`}
          onClick={onClickToDeleteModeToggle}
          title="Toggle click to delete mode"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/>
          </svg>
        </button>
      )}

      <button
        className={`mobile-control-btn mobile-suggestions-btn ${suggestionsMode ? 'active' : ''}`}
        onClick={onSuggestionsModeToggle}
        title={suggestionsMode ? "Suggestions mode active - Click for alternatives" : "Toggle suggestions mode"}
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
        </svg>
      </button>
      </div>

      <Link to="/" className="mobile-control-btn mobile-new-btn mobile-new-btn-right" title="New transcript">
        +
      </Link>
    </div>
  );
};

export const MobileTranscriptControlsSettings = ({
  onCopy,
  onShare,
  onSettingsToggle,
  onHelpToggle,
  showControls = true
}) => {
  if (!showControls) {
    return null;
  }

  return (
    <div className="mobile-control-buttons-group">
        {onCopy && (
          <button type="button" className="mobile-control-btn" onClick={onCopy} title="Copy transcript">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/>
            </svg>
          </button>
        )}
        {onShare && (
          <button type="button" className="mobile-control-btn" onClick={onShare} title="Share transcript">
            <svg width="20" height="20" viewBox="0 0 16 16" fill="currentColor">
              <path d="M13.5 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.5 2.5 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5zm-8.5 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm11 5.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z"/>
            </svg>
          </button>
        )}
        <button
          className="mobile-control-btn"
          onClick={onSettingsToggle}
          title="Settings"
          type="button"
        >
          ⚙️
        </button>
      <div className="mobile-usernav-wrapper">
        <UserNav onHelpToggle={onHelpToggle} />
      </div>
    </div>
  );
};

export default MobileTranscriptControls;